__turbopack_context__.v({
  "Price": "PromoRibbon-module__D6i7JG__Price",
  "PromoRibbon": "PromoRibbon-module__D6i7JG__PromoRibbon",
  "PromoRibbon-retailer": "PromoRibbon-module__D6i7JG__PromoRibbon-retailer",
  "button-wrapper": "PromoRibbon-module__D6i7JG__button-wrapper",
  "dollar": "PromoRibbon-module__D6i7JG__dollar",
  "grid-item": "PromoRibbon-module__D6i7JG__grid-item",
  "instructional": "PromoRibbon-module__D6i7JG__instructional",
  "large-2": "PromoRibbon-module__D6i7JG__large-2",
  "large-3": "PromoRibbon-module__D6i7JG__large-3",
  "large-4": "PromoRibbon-module__D6i7JG__large-4",
  "promo-subheader": "PromoRibbon-module__D6i7JG__promo-subheader",
  "promo-title": "PromoRibbon-module__D6i7JG__promo-title",
  "promoItem": "PromoRibbon-module__D6i7JG__promoItem",
  "promos": "PromoRibbon-module__D6i7JG__promos",
});
